import { listItemButtonClasses, listItemTextClasses } from '@mui/material';

import type { SxProp } from 'src/types/mui';

export const listItemTextStyles: SxProp = {
  marginLeft: '32px',
  whiteSpace: 'normal',
};

export const sidebarStyles: SxProp = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
};

export const mobileSidebarStyles: SxProp = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '100%',
};

export const wrapperStyles: SxProp = {
  paddingTop: '22px',
};

export const wrapperStylesHideLogo: SxProp = {
  paddingTop: '10px',
};

export const logoStyles: SxProp = {
  display: 'flex',
  justifyContent: 'center',
  paddingLeft: '10px',
  paddingRight: '10px',
  margin: '0 auto 40px auto',
  maxWidth: '220px',
};

export const navListItemStyles: SxProp = {
  borderRadius: '8px',
  padding: '0 8px',
  color: 'slate.300',
  [` .${listItemTextClasses.root}`]: {
    color: 'black',
  },
  [`.${listItemButtonClasses.selected}`]: {
    [` .${listItemTextClasses.root}`]: {
      color: 'text.primary',
    },
  },
  [` .${listItemButtonClasses.root}`]: {
    borderRadius: '8px',
  },
};

export const listItemIconStyles: SxProp = {
  fontSize: '30px',
};

export const listItemEndIconStyles: SxProp = {
  fontSize: '20px',
};

export const tabsContainerStyles: SxProp = {
  display: 'flex',
  flexGrow: 1,
  flexShrink: 1,
  flexBasic: '0%',
  flexDirection: 'column',
  height: '100%',
};

export const signOutButtonStyles: SxProp = theme => ({
  color: theme.palette.red?.[500],
});

export const versionBoxStyles: SxProp = {
  textAlign: 'left',
  paddingLeft: '5px',
};

export const versionLabelStyles: SxProp = theme => ({
  color: theme.palette.grey[500],
});
